import React from 'react';
import NewVMStep2 from './NewVSStep1';

const NewVSStep1Container = ({ formikProp, regionsData, sizeData }) => {
  return <NewVMStep2 sizeData={sizeData} regionsData={regionsData} formikProp={formikProp} />;
};

export default NewVSStep1Container;
